import * as types from '../constants/actionTypes';
import { fromJS , toJS } from 'immutable';
import { languageSetting  } from '../constants/string';

const locale = (navigator.languages !== undefined) ? ((!(navigator.languages[0] === 'zh' || navigator.languages[0] === 'zh-HK' || navigator.languages[0] === 'zh-TW') )? 'en' : 'zh') : 'zh';
const preferenceInitialState = {
  locale : locale,
  string : {}
};

preferenceInitialState.string = languageSetting(preferenceInitialState.locale)

function preferenceReducer(state = preferenceInitialState , action){
  state = fromJS(state);
  switch(action.type){
    case types.SETTING_LANGUAGE:
      return state
        .setIn(['locale'],action.value)
        .setIn(['string'],languageSetting(action.value))
        .toJS()
      break;
    default:
      return state.toJS();
      break;
  }
}

export default preferenceReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/preferenceReducer.js
 **/